import { AUDIT_FIELDS_FLAT } from './audit_fields'
import { ANIMAL_FIELDS_FLAT } from './animal_fields'

export const MEASUREMENT_BASE_FIELDS = [
	{
		field: '_id',
		label: 'ID',
		nofilter: true, // pointless
		readonly: true
	},
	{
		field: 'tags',
		label: 'Tags',
		nofilter: false,
		values: '/listoftags',
		type: 'tags',
		label_key: 'name'

	},
	{
		field: 'animalId',
		label: 'Animal ID',
		nofilter: false
	},
	{
		field: 'animal.animalName',
		label: 'Animal Name',
		readonly: true
	},
]

export const MEASUREMENT_EVENT_META_FIELDS = [
	{
		field: 'event.starting_date',
		label: 'Starting date (client time!)'
	},
	{
		field: 'event.experiment_id',
		label: 'Experiment ID'
	},
	{
		field: 'event.codingstatus',
		label: 'Coding status',
		type: 'enum',
		values: [
			'unknown',
			'just_created',
			'just_uploaded',
			'auto_concat_ok',
			'auto_concat_failed',
			'redo_auto_concat',
			'meta_data_ok',
			'video_ok',
			'needs_sync',
			'sync_ok',
			'coding_ok',
			'needs_attention',
			'finished',
			'deletable'
		]
	},
	{
		field: 'event.external_resource_link',
		label: 'External Resource Link (use this for e.g. linking videos!)',
		type: 'link'
	},
	{
		field: 'event.ending_date',
		label: 'Ending date (client time!)'
	},
	{
		field: 'event.first_batch_date',
		label: 'First batch (client time!)'
	},
	{
		field: 'event.last_batch_date',
		label: 'Last batch (client time!)'
	},
	{
		field: 'event.protocol',
		label: 'Protocol'
	},
	{
		field: 'event.comment',
		label: 'Comment'
	},
]

const sheetTags = [
	'sensdog_main',
	'senshorse_main',
	'senshorse_simplified',
	'sst',
	'srd',
	'sync_only',
	'cogbat_exploration',
	'KH2018_movements',
	'KH2018_movements_seq',
	'other (specify in comments)',
]

export const MEASUREMENT_EVENT_FILES_FIELDS = [
	{
		field: 'event.batches',
		label: 'Batches',
		nofilter: true, // TODO array, needs more than one filter
		readonly: true
	},
	{
		field: 'event.data',
		label: 'Data (concat JSON)',
		nofilter: true, // TODO ObjectId, needs "exists" ($ne:null) and "not exists" ($eq:null) filters
		accept: '*.json'
	},
	{
		field: 'event.videos',
		label: 'Videos',
		nofilter: true, // TODO array, needs more than one filter
		tags: ['other', 'sensdog_app', 'video'],
		accept: 'video/*',
		readonly: true
	},
	{
		field: 'event.codingsheets',
		label: 'Coding sheets (solomon legacy)',
		nofilter: true, // TODO array, needs more than one filter
		tags: sheetTags,
		accept: '*.csv'
	},
	{
		field: 'event.archsheets',
		label: 'Arch sheets (solomon legacy)',
		nofilter: true, // TODO array, needs more than one filter
		tags: sheetTags,
		accept: '*.arch'
	},
	{
		field: 'event.otherfiles',
		label: 'Other files',
		nofilter: true, // TODO array, needs more than one filter
		accept: '*'
	},
]

export const MEASUREMENT_TECHNICAL_FIELDS = [
	{
		field: 'technical.device_id',
		label: 'Device ID'
	},
	{
		field: 'technical.device_name',
		label: 'Device Name'
	},
	{
		field: 'technical.device_model_name',
		label: 'Device Model Name'
	},
	{
		field: 'technical.software_version',
		label: 'Software version'
	},
	{
		field: 'technical.number_of_data_types',
		label: 'Number of data types',
		type: 'number',
		readonly: true
	},
	{
		field: 'technical.data_types',
		label: 'Data Types',
		type: 'enum',
		readonly: true
	},
	{
		field: 'technical.orientation',
		label: 'Orientation',
		type: 'enum',
		values: [
			'old',
			'new',
			'harness',
			'hand_left',
			'hand_right',
			'unknown'
		]
	},
	{
		field: 'technical.device_type',
		label: 'Device type'
	},
]

export const MEASUREMENT_LISTED_FIELDS_FLAT = [
	...MEASUREMENT_BASE_FIELDS,
	...ANIMAL_FIELDS_FLAT.filter(f => (f.field !== '_id' && f.field !== 'animalName')).map(f => Object.assign({}, f, {
		field: `animal.${f.field}`,
		label: `Animal ${f.label}`,
		readonly: true // just in case B)
	})),
	...MEASUREMENT_TECHNICAL_FIELDS,
	...MEASUREMENT_EVENT_META_FIELDS,
	...MEASUREMENT_EVENT_FILES_FIELDS,
	...AUDIT_FIELDS_FLAT
]
